import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import ActivityMonitorsSubmenu from "../../components/menus/sub-menu/subtypes/ActivityMonitorsSubmenu";
import DeviceListCard from "../../components/device-cards/DeviceListCard";
import { getListViewData, clearListViewData } from "../../actions/list-view";

class DeviceListView extends Component {
  componentDidMount = () => {
        return this.props.getListViewData("activity-monitors");
  };

  componentWillUnmount = () => {
    this.props.clearListViewData();
  };

  render() {
    if (this.props.listViewData) {
      return (
        <Fragment>
          <ActivityMonitorsSubmenu
            nrResults={this.props.listViewData?._meta?.totalCount}
          />
          <div className="bacecontainer pl-2">
            <DeviceListCard
              subtype={"activity-monitors"}
              subpage={"measurement-data"}
            />
          </div>
        </Fragment>
      );
    } else {
      return <div></div>;
    }
  }
}

function mapStateToProps(state) {
  return { listViewData: state.listViewReducer.listViewData };
}

export default withRouter(
  connect(mapStateToProps, { getListViewData, clearListViewData })(
    DeviceListView
  )
);
